/*
 * AppConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */


export const LOGIN_SUCCESS = 'app.LOGIN_SUCCESS';
export const LOGOUT_SUCCESS = 'app.LOGOUT_SUCCESS';
export const API_SUCCESS = 'app.API_SUCCESS';
export const API_FAIL = 'app.API_FAIL';
export const SET_SELECTED_POLICY_ID = 'app.SELECTED_POLICY_ID';
export const SET_ERROR = 'app.SET_ERROR';
export const CLEAR_ERROR = 'app.CLEAR_ERROR';
export const FNOL_REPORT_DATE_VALIDATION_STATUS = 'app.FNOL_REPORT_DATE_VALIDATION_STATUS';
export const SET_VALIDATE_STEP = 'app.SET_VALIDATE_STEP';
export const SET_MEDICAL_AUTHORITY_FORM_LINK = 'app.SET_MEDICAL_AUTHORITY_FORM_LINK';
export const SET_MEDICAL_CERTIFICATE_FORM_LINK = 'app.SET_MEDICAL_CERTIFICATE_FORM_LINK';
export const SET_CLAIM_TYPES = 'app.SET_CLAIM_TYPES';
export const SET_CHILD_BENEFITS = 'app.SET_CHILD_BENEFITS';
export const SET_VALIDATION_REPORT_DATE_ERROR = 'app.SET_VALIDATION_REPORT_DATE_ERROR';
export const DEFAULT_LOCALE = 'en';
export const SET_JSON_VERSION = 'app.SET_JSON_VERSION';
export const SET_INSURED_LIST = 'app.SET_INSURED_LIST';
export const SET_CLAIM_PAYMENT_VERSION = 'app.SET_CLAIM_PAYMENT_VERSION';
export const SET_IS_LINKED_COVER = 'app.SET_IS_LINKED_COVER';
export const SET_INCIDENT_DATE = 'app.SET_INCIDENT_DATE';
export const SET_SHOW_ELECTRONIC_CONSENT = 'app.SET_SHOW_ELECTRONIC_CONSENT';
export const SET_DECLARATION_CLAIMS_ADMIN_COMPANY_NAME = 'app.SET_DECLARATION_CLAIMS_ADMIN_COMPANY_NAME';
export const SET_TPA_NAME = 'app.SET_TPA_NAME';
export const SET_CARRIER_NAME = 'app.SET_CARRIER_NAME';
export const SET_EMAIL_ADDRESS = 'app.SET_EMAIL_ADDRESS';
export const SET_PHONE_NUMBER = 'app.SET_PHONE_NUMBER';
export const SET_CLIENT_ID = 'app.SET_CLIENT_ID';
export const SET_SHOW_REQUIRE_DOCUMENT = 'app.SET_SHOW_REQUIRE_DOCUMENT';
export const SET_IS_CLAIM_GROUP_ALLOWED = 'app.SET_IS_CLAIM_GROUP_ALLOWED';
export const SET_CELLCAPTIVE_COUNTRY_ID = 'app.SET_CELLCAPTIVE_COUNTRY_ID';
export const SET_INIT_CLAIM_TYPES_SUCCESS = 'app.SET_INIT_CLAIM_TYPES_SUCCESS';
export const SET_ZURICH_UHC = 'app.SET_ZURICH_UHC';
export const SET_POLICY_PURCHASE_DATE = 'app.SET_POLICY_PURCHASE_DATE';
export const SET_POLICY_EFFECTIVE_DATE = 'app.SET_POLICY_EFFECTIVE_DATE';
export const SET_POLICY_TERMINATION_DATA = 'app.SET_POLICY_TERMINATION_DATA';
export const SET_CLAIMANT_ID = 'app.SET_CLAIMANT_ID';
export const SET_GUARDIAN_CLIENT_ROLES = 'app.SET_GUARDIAN_CLIENT_ROLES';
export const SET_APPSURE_INSTANCE_SCTI = 'app.SET_APPSURE_INSTANCE_SCTI';
export const SET_POLICY_TYPE_CODE = 'app.SET_POLICY_TYPE_CODE';
export const SET_POLICY_PLAN_IDS = 'app.SET_POLICY_PLAN_IDS';
export const SET_SPECIFIED_ITEMS = 'app.SET_SPECIFIED_ITEMS';
export const SET_POLICY_CANCELLED = 'app.SET_POLICY_CANCELLED';
export const SET_SHOW_TRAWICK_FNOL_REFACTORING = 'app.SET_SHOW_TRAWICK_FNOL_REFACTORING';
export const SET_SHOW_TRAWICK_PAYMENT_SCREEN = 'app.SET_SHOW_TRAWICK_PAYMENT_SCREEN';
export const SET_EVENT_DESCRIPTION_LIMIT = 'app.SET_EVENT_DESCRIPTION_LIMIT';
export const SET_CELL_CAPTIVE_NAME = 'app.SET_CELL_CAPTIVE_NAME';
export const SET_IS_SHOW_GST_QUESTION = 'app.SET_IS_SHOW_GST_QUESTION';
export const VALIDATE_VERIFICATION_CODE = 'app.VALIDATE_VERIFICATION_CODE';
export const SET_FORM_HAS_CHANGES = 'app.SET_FORM_HAS_CHANGES';


export const LIST_CELLCAPTIVE_NAME = {
  CELL_CAPTIVE_NAME_VISITORS_TO_CANADA: 'Visitors to Canada',
  CELL_CAPTIVE_NAME_STUDENT: 'Student',
  CELL_CAPTIVE_NAME_IA_STUDENT: 'IA Student',
  CELL_CAPTIVE_NAME_IA_TUGO_STUDENT: 'TuGo International Student',
  CELL_CAPTIVE_NAME_TUGO_CANADIAN_STUDENT: 'TuGo Canadian Student',
  CELL_CAPTIVE_NAME_TUGO_OPTIMUM: 'Optimum',
  CELL_CAPTIVE_NAME_TRAVELLER: 'Traveller',
};
export const SET_SHOW_INSURED_MULTI_CLAIMANT = 'app.SET_SHOW_INSURED_MULTI_CLAIMANT';
export const SET_ENABLE_FORM_DYNAMIC_PAYMENT_DETAIL = 'app.SET_ENABLE_FORM_DYNAMIC_PAYMENT_DETAIL';

export const LIST_POLICY_TYPE_CODE = {
  PLAN_ID_MEDICAL_BENEFITS_PRIMARY: 'PL-SMED-21',
  PLAN_ID_MEDICAL_BENEFITS_SECONDARY: 'PL-SMED-22',
  PLAN_ID_TRIPCAN_BENEFITS: 'PL-STCAN-8',
  PLAN_ID_TRIP_INTERRUPTION_BENEFITS: 'PL-STI-4',
  PLAN_ID_AD_AND_D_BENEFITS: 'PL-SADD-6',
  LIST_POLICY_PLAN_ID_SHOW_MEDICAL_BENEFITS: ['PL-SMED-21', 'PL-SMED-22', 'PL-SMED-28', 'PL-SMED-47', 'PL-SMED-48', 'PL-MMED-1', 'PL-SMED-14', 'PL-MMED-2-T1', 'PL-MMED-2-T2', 'PL-MMED-2-T3', 'PL-MMED-3-T1', 'PL-MMED-3-T2', 'PL-MMED-3-T3', 'PL-SMED-1-T1', 'PL-SMED-1-T2', 'PL-SMED-1-T3', 'PL-SMED-3-T1', 'PL-SMED-3-T2', 'PL-SMED-3-T3', 'PL-SMED-4-T1', 'PL-SMED-4-T2', 'PL-SMED-4-T3', 'PL-SPCK-2-T1', 'PL-SPCK-2-T2', 'PL-SPCK-2-T3'],
  LIST_POLICY_PLAN_ID_SHOW_TRIP_CANCELLATION: ['PL-STCAN-8', 'PL-MTCAN-1', 'PL-STCAN-7', 'PL-MTCAN-2', 'PL-STCAN-9', 'PL-VSTC-1', 'PL-SPCK-2-T1', 'PL-SPCK-2-T2', 'PL-SPCK-2-T3', 'PL-MPCK-6', 'PL-SPCK-17'],
  LIST_POLICY_PLAN_ID_SHOW_TRIP_INTERRUPTION: ['PL-STI-4', 'PL-MTI-1', 'PL-STI-3', 'PL-SPCK-2-T1', 'PL-SPCK-2-T2', 'PL-SPCK-2-T3', 'PL-MPCK-6', 'PL-SPCK-17'],
  LIST_POLICY_PLAN_ID_SHOW_AD_AND_D: ['PL-SADD-6', 'PL-MADD-1', 'PL-SADD-5', 'PL-SPCK-2-T1', 'PL-SPCK-2-T2', 'PL-SPCK-2-T3', 'PL-MPCK-6', 'PL-SPCK-17'],
  LIST_POLICY_PLAN_ID_AD_AND_D_TRAVELLER: ['PL-MADD-1', 'PL-SADD-5', 'PL-MPCK-6', 'PL-SPCK-17'],
  LIST_POLICY_PLAN_ID_SHOW_BAGGAGE_TRAVELLER: ['PL-SBAG-3-S', 'PL-SBAG-3-F', 'PL-MPCK-6', 'PL-SPCK-17'],
  LIST_POLICY_PLAN_ID_SHOW_RENTAL_CAR_TRAVELLER: ['PL-SSRC-3'],
  LIST_POLICY_PLAN_ID_TUGO_BENEFIT_TILES: ['PL-SMED-21', 'PL-SMED-22', 'PL-SMED-28', 'PL-SMED-47', 'PL-SMED-48', 'PL-STCAN-8', 'PL-MTCAN-1', 'PL-STCAN-7', 'PL-MTCAN-2', 'PL-STCAN-9', 'PL-VSTC-1', 'PL-STI-4', 'PL-MTI-1', 'PL-STI-3', 'PL-SADD-6', 'PL-MADD-1', 'PL-SADD-5', 'PL-MMED-1', 'PL-SMED-14', 'PL-MMED-2-T1', 'PL-MMED-2-T2', 'PL-MMED-2-T3', 'PL-MMED-3-T1', 'PL-MMED-3-T2', 'PL-MMED-3-T3', 'PL-SMED-1-T1', 'PL-SMED-1-T2', 'PL-SMED-1-T3', 'PL-SMED-3-T1', 'PL-SMED-3-T2', 'PL-SMED-3-T3', 'PL-SMED-4-T1', 'PL-SMED-4-T2', 'PL-SMED-4-T3', 'PL-SBAG-3-S', 'PL-SBAG-3-F', 'PL-SSRC-3', 'PL-SPCK-2-T1', 'PL-SPCK-2-T2', 'PL-SPCK-2-T3', 'PL-MPCK-6', 'PL-SPCK-17'],
  INBOUND_STUDENT_TIER_1: 'PL-SMED-39-T1',
  INBOUND_STUDENT_TIER_2: 'PL-SMED-39-T2',
  INBOUND_STUDENT_TIER_3: 'PL-SMED-39-T3',
  OUTBOUND_STUDENT: 'PL-SMED-40',
  LIST_POLICY_TYPE_CODE_STUDENT: ['PL-SMED-39-T1', 'PL-SMED-39-T2', 'PL-SMED-39-T3', 'PL-SMED-40'],
  LIST_POLICY_TYPE_CODE_STANDARD_VTC: ['PL-SMED-21', 'PL-SMED-22', 'PL-SMED-28'],
  LIST_POLICY_TYPE_CODE_TRAVELLER: ['PL-SMED-21', 'PL-SMED-22', 'PL-STCAN-7', 'PL-STI-3', 'PL-SBAG-3-S', 'PL-MTCAN-2', 'PL-STCAN-9', 'PL-MMED-2-T1', 'PL-MMED-2-T2', 'PL-MMED-2-T3', 'PL-MMED-3-T1', 'PL-MMED-3-T2', 'PL-MMED-3-T3', 'PL-SMED-1-T1', 'PL-SMED-1-T2', 'PL-SMED-1-T3', 'PL-SMED-3-T1', 'PL-SMED-3-T2', 'PL-SMED-3-T3', 'PL-SMED-4-T1', 'PL-SMED-4-T2', 'PL-SMED-4-T3', 'PL-SPCK-2-T1', 'PL-SPCK-2-T2', 'PL-SPCK-2-T3', 'PL-MPCK-6', 'PL-SPCK-17'],
  LIST_POLICY_TYPE_CODE_OPTIMUM: ['PL-MMED-1', 'PL-SMED-14'],
  LIST_POLICY_TYPE_CODE_OTHER_BENEFIT_NBA: ['PL-SMED-47', 'PL-SMED-48'],
  LIST_POLICY_TYPE_CODE_TRIP_CANCELLATION_TRAVELLER: ['PL-MTCAN-1', 'PL-STCAN-7', 'PL-MTCAN-2', 'PL-STCAN-9', 'PL-SPCK-2-T1', 'PL-SPCK-2-T2', 'PL-SPCK-2-T3', 'PL-MPCK-6', 'PL-SPCK-17'],
  LIST_POLICY_PLAN_ID_TRIP_INTERRUPTION_TRAVELLER: ['PL-MTI-1', 'PL-STI-3', 'PL-MTCAN-2', 'PL-STCAN-9', 'PL-SPCK-2-T1', 'PL-SPCK-2-T2', 'PL-SPCK-2-T3', 'PL-MPCK-6', 'PL-SPCK-17'],
};



// WEBPACK FOOTER //
// ./app/containers/App/constants.js